import Avatar from 'antd/lib/avatar/avatar';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { ActionButtonContainer } from 'components/DataCard/styled';
import InputFieldsGenerator from 'components/InputFieldsGenerator';
import { getValueAndQueryWithSelectSeparator } from 'constants/selectValueSeparator';
import { Form, Formik } from 'formik';
import React from 'react';
import { getDefaultAvatarUrl } from 'utils';
import * as Yup from 'yup';

import { ITransactionTypeSpecificsInputProps } from './types';

const priceSchemaObject = Yup.object({
  priceRON: Yup.number().typeError('Must be number').required('Required'),
  priceInPerson: Yup.number().typeError('Must be number').required('Required'),
});

const TransactionTypeSpecificsInput: React.FC<ITransactionTypeSpecificsInputProps> = ({
  priceDetail,
  index,
  isVisible,
  onPriceChange,
  onDelete,
  userDetail,
  onCreateNewPriceClick,
}) => {
  const userId = userDetail?.id || '';
  // const tagProps = getRoleTagProps(userDetail?.role);
  const priceInputs = [
    {
      name: `priceInPerson`,
      label: 'In Person',
      inputSettings: { prefix: '$' },
      defaultValue: priceDetail?.priceInPerson,
      onChange: (v: string) => {
        onPriceChange?.(getValueAndQueryWithSelectSeparator(v)[0], userDetail?.id || '', false);
      },
      sideFields: [
        {
          name: `priceRON`,
          label: 'RON',
          inputSettings: { prefix: '$' },
          defaultValue: priceDetail?.priceRON,
          size: {
            span: 12,
          },
          onChange: (v: string) => {
            onPriceChange?.(getValueAndQueryWithSelectSeparator(v)[0], userDetail?.id || '', true);
          },
        },
      ],
    },
  ];

  const userFullName = `${userDetail?.firstName} ${userDetail?.lastName}`;
  return (
    <div key={userId} className='specific-price-detail' style={{ display: isVisible ? undefined : 'none' }}>
      <div className='title'>
        <Avatar
          style={{ minWidth: 40, minHeight: 40 }}
          className='gx-mr-2'
          src={userDetail?.avatar?.thumbnailPipeFrom || getDefaultAvatarUrl(userFullName)}
        />
        <div className='gx-mr-2 gx-flex-column gx-justify-items-center'>
          <div className='gx-font-weight-medium'>{userFullName}</div>
          {/* <Tag color={tagProps.color}>{tagProps.text}</Tag> */}
        </div>
        <ActionButtonContainer
          onClick={() => {
            onDelete?.(userId, index);
          }}
          style={{ minWidth: 50 }}
          className='gx-dot delete-specific-price-button'
          $iconOnHoverColor='red'
          $activeColor='transparent'>
          <i className='icon icon-trash gx-text-grey' />
        </ActionButtonContainer>
      </div>
      <div className='price'>
        {!!priceDetail && (
          <Formik
            validationSchema={priceSchemaObject}
            onSubmit={() => {}}
            initialValues={{ priceRON: priceDetail?.priceRON, priceInPerson: priceDetail?.priceInPerson }}>
            <Form>
              <InputFieldsGenerator formFields={priceInputs} />
            </Form>
          </Formik>
        )}
        {!priceDetail && (
          <ButtonWithSpinner
            style={{ padding: 0, justifyContent: 'flex-start' }}
            onClick={() => {
              onCreateNewPriceClick?.(userDetail);
            }}
            buttonType='text'
            bgColor='transparent'
            color='#038FDE'>
            Set Price
          </ButtonWithSpinner>
        )}
      </div>
      <ActionButtonContainer
        onClick={() => {
          onDelete?.(userId, index);
        }}
        style={{ minWidth: 50, display: priceDetail ? undefined : 'none' }}
        className='gx-dot gx-p-1 gx-mb-1 delete-specific-price-button'
        $iconOnHoverColor='red'
        $activeColor='transparent'>
        <i className='icon icon-trash gx-text-grey' />
      </ActionButtonContainer>
    </div>
  );
};

export default TransactionTypeSpecificsInput;
